/**
* A polyfill for Array.isArray
*/
if (!Array.isArray)
{
    Array.isArray = function (arg)
    {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}



//////////////////
// WEBPACK FOOTER
// ./polyfills/Array.isArray.js
// module id = 395
// module chunks = 0